import { queryClient } from '@/lib/reactQuery';
import { GET_CALENDAR_PERIOD_QUERY_KEY } from '../api/getCalendarPeriod';
import { GET_STUDENTS_SCHEDULING_DETAILS_QUERY_KEY } from '../api/getStudentsSchedulingDetails';
import { GET_TIMESLOTS_PER_DAY_QUERY_KEY } from '../api/getTimeslotsPerDay';
import { GET_UPCOMING_APPOINTMENTS_QUERY_KEY } from '../api/getUpcomingAppointments';

export const invalidateSchedulingQueries = () => {
  void queryClient.invalidateQueries({
    queryKey: [GET_UPCOMING_APPOINTMENTS_QUERY_KEY],
    exact: false,
    refetchType: 'all',
  });
  void queryClient.invalidateQueries({ queryKey: [GET_CALENDAR_PERIOD_QUERY_KEY] });
  void queryClient.invalidateQueries({ queryKey: [GET_STUDENTS_SCHEDULING_DETAILS_QUERY_KEY] });
  void queryClient.invalidateQueries({ queryKey: [GET_TIMESLOTS_PER_DAY_QUERY_KEY] });
};
